<template>
    <div :class="$style.container">
        <Image
            data-allow-mismatch
            withFadeInOnLoad
            :class="$style.item_icon_override"
            loading="lazy"
            :src="props.icon"
            :alt="props.title"
        />
        <Typography
            is="span"
            :class="$style.caption"
            type="label"
            size="xs"
            :responsive="false"
            semibold
        >
            {{ title }}
        </Typography>
        <div :class="$style.likeTextRow">
            <Icon
                name="like"
                :class="$style.likeIcon"
            />
            <Typography
                type="label"
                size="xs"
                :responsive="false"
                semibold
            >
                {{ likes }}
            </Typography>
        </div>
    </div>
</template>

<script setup lang="ts">
import Icon from '@/components/Icon/Icon.vue'
import Image from '@/components/Image/Image.vue'
import Typography from '@/components/Typography.vue'

interface titleProps {
    title: string
    icon: string
    likes: string
}

const props = defineProps<titleProps>()
</script>

<style module>
.container {
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 8px;
    display: grid;
    grid-template-columns: 52px 1fr;
    grid-template-rows: 1fr min-content;
    gap: 4px 8px;
    width: 100%;
    pointer-events: none;
    background: linear-gradient(rgb(255, 255, 255) 0%, rgba(0, 0, 0, 0) 0%, rgb(29, 28, 38) 100%);
    height: 162px;
}

.caption {
    display: flex;
    align-items: flex-end;
}

.likeTextRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    padding-bottom: 4px;
}

.likeIcon {
    height: 16px;
    width: 16px;
}

.item_icon_override {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    flex-shrink: 0;
    grid-row: span 2;
    align-self: end;
}
</style>
